import { ApolloClient } from 'apollo-client';
// import { createHttpLink } from 'apollo-link-http';
import { InMemoryCache } from 'apollo-cache-inmemory';
import { Auth } from 'aws-amplify';
import { createUploadLink } from 'apollo-upload-client';
import { ApolloLink } from 'apollo-link';
import { onError } from 'apollo-link-error';

const BASE_URL = process.env.API_BASE_URL;

// Inject custom header for API authentication
const customFetch = async (uri, options) => {
  let authToken = null;

  try {
    //the id/access tokens get refreshed automatically when accessed, so it is preferable to read from the cognito session
    let currentSession = await Auth.currentSession();
    authToken = currentSession.getIdToken().getJwtToken();
  } catch (err) {
    console.error('Error retrieving active session: ', err);
  }

  if (authToken) {
    options.headers.Authorization = `${authToken}`;
  }
  return fetch(uri, options);
};

// Error Handling
const errorLink = onError(({ graphQLErrors, networkError }) => {
  if (graphQLErrors)
    graphQLErrors.map(({ message, locations, path }) => {
      console.log(
        `[GraphQL error]: Message: ${message}, Location: ${locations}, Path: ${path}`
      );
    });
  if (networkError) {
    console.log(`[Network error]: ${networkError}`);
    if (networkError.statusCode === 401) {
      // TODO: handle API auth errors
    }
  }
});

const uploadLink = createUploadLink({
  uri: BASE_URL,
  fetch: customFetch,
});

const defaultOptions = {
  watchQuery: {
    fetchPolicy: 'network-only',
    errorPolicy: 'ignore',
  },
  query: {
    fetchPolicy: 'network-only',
    errorPolicy: 'all',
  },
  mutate: {
    errorPolicy: 'all',
  },
};

const cache = new InMemoryCache();

const client = new ApolloClient({
  link: ApolloLink.from([errorLink, uploadLink]),
  cache,
  defaultOptions,
});

export default client;
